module.exports = __webpack_public_path__ + "uarm-images/tinymce-imaps_icon.png";